import React, { useContext } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, btnName, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import FAQsPopup from "./FAQ's_popup";

const FaqS = () => {
  const { setAllPopupState, allPopupState } = useContext(
    ByteCardBuilderContext
  );
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody className="support-ticket-font box-border-div">
            <Row>
              <div className="col-12">
                <CardBuilderHeaderSection name="FAQ's" />
              </div>
              <OpenPopupBtn
                openPopup={() =>
                  OpenModalCommonFunc(Cases.FAQS, setAllPopupState)
                }
                name={btnName.FAQS}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>

      <CommonPopup
        open={allPopupState.FAQsPopup}
        close={() => OpenModalCommonFunc(Cases.FAQS, setAllPopupState, false)}
        modalName={modalsName.FAQS}
        modalCase={Cases.FAQS}
        content={<FAQsPopup />}
      />
    </>
  );
};

export default FaqS;
